import React, {useState} from 'react'

const defaultValues = {
  headerHeight: 0,
  setHeaderHeight: () => {}
}

const RootContext = React.createContext(defaultValues)

const useRootState = () => {
  const context = React.useContext(RootContext)
  if (context === undefined) {
    throw new Error('useRootState must be used within a RootProvider')
  }
  return context
}

const RootProvider = ({children}) => {
  const [headerHeight, setHeaderHeight] = useState(0)

  return (
    <RootContext.Provider value={{
      headerHeight,
      setHeaderHeight
    }}>
      {children}
    </RootContext.Provider>
  )
}

export {RootProvider, useRootState}
